import { useRef, useEffect, useCallback } from "react";

export default function useSound(audioPath) {
  const audioRef = useRef(null);

  useEffect(() => {
    if (audioPath) {
      audioRef.current = new Audio(audioPath);
    }

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, [audioPath]);

  const playSound = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch((err) => {
        console.error("오디오 재생 실패:", err, audioPath);
      });
    }
  }, [audioPath]);

  return playSound;
}
